import {
  CKDrawer,
  CKTab,
  CKTabList,
  CKTabPanel,
  CKTabPanels,
  CKTabs,
} from 'clearkit';
import { useState } from 'react';

import { AccountPlan } from './AccountPlan';
import { FeatureFlags } from './FeatureFlags';

export default function DeveloperPanel({
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
}) {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <CKDrawer
      hasBlurredBackdrop={false}
      hasClickOutside
      isVisible={open}
      onToggle={onClose}
      size="lg"
    >
      <CKDrawer.Header>
        <CKDrawer.Heading>Dev Tools</CKDrawer.Heading>
      </CKDrawer.Header>
      <CKDrawer.Body className="h-full min-h-0">
        <CKTabs
          className="h-full min-h-0 grid grid-rows-auto-1fr"
          index={tabIndex}
          isBordered
          onChange={setTabIndex}
        >
          <CKTabList aria-label="My tabs" className="h-full min-h-0 px-4">
            <CKTab label="Feature Flags">Feature Flags</CKTab>
            <CKTab label="Account Plans">Account Plans</CKTab>
          </CKTabList>
          <CKTabPanels className="min-h-0 overflow-auto">
            <CKTabPanel className="h-full">
              <FeatureFlags />
            </CKTabPanel>
            <CKTabPanel>
              <AccountPlan />
            </CKTabPanel>
          </CKTabPanels>
        </CKTabs>
      </CKDrawer.Body>
    </CKDrawer>
  );
}
